import { SkeletonSvg } from './styled-components'

const SkeletonPin = (
  <SkeletonSvg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="48"
    viewBox="0 0 33 48"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1875 0C7.3499 0 0.1875 6.696 0.1875 14.9568C0.1875 25.7672 16.1875 48 16.1875 48C16.1875 48 32.1875 25.7672 32.1875 14.9568C32.1875 6.69599 25.0219 0 16.1875 0"
      fill="#EDEDF1"
    />
  </SkeletonSvg>
)

const UsermemberIcon = () => (
  <svg
    height="48"
    width="48"
    fill="none"
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00195 24.0005C5.00195 13.5071 13.5085 5.00049 24.002 5.00049C34.4954 5.00049 43.002 13.5071 43.002 24.0005C43.002 26.4962 42.5208 28.8796 41.6461 31.0628C42.1766 31.669 42.611 32.3614 42.9257 33.1162C44.2562 30.3591 45.002 27.2669 45.002 24.0005C45.002 12.4025 35.5999 3.00049 24.002 3.00049C12.404 3.00049 3.00195 12.4025 3.00195 24.0005C3.00195 35.5985 12.404 45.0005 24.002 45.0005C27.2676 45.0005 30.3592 44.2551 33.1158 42.9251C32.361 42.6104 31.6687 42.1759 31.0625 41.6453C28.8798 42.5196 26.497 43.0005 24.002 43.0005C13.5085 43.0005 5.00195 34.4939 5.00195 24.0005Z"
      fill="#141A21"
      fillRule="evenodd"
    />
    <path
      d="M23.7543 22.9272C26.9097 22.9272 29.4677 20.3692 29.4677 17.2138C29.4677 14.0584 26.9097 11.5005 23.7543 11.5005C20.599 11.5005 18.041 14.0584 18.041 17.2138C18.041 20.3692 20.599 22.9272 23.7543 22.9272Z"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M12.574 35.2731C12.8904 33.0427 13.8053 30.9395 15.2209 29.187C16.6365 27.4345 18.5003 26.0982 20.6144 25.3198L20.6575 25.3431C21.1387 25.5889 21.645 25.7823 22.1675 25.9198C22.2209 25.9198 22.2775 25.9431 22.3275 25.9564C22.5408 26.0064 22.7509 26.0431 22.9643 26.0731C23.0376 26.0731 23.1042 26.0964 23.1742 26.1031C23.4454 26.1342 23.7179 26.151 23.9909 26.1532C24.2593 26.151 24.5274 26.1343 24.7941 26.1031L24.991 26.0798C25.247 26.0455 25.5004 25.9965 25.7507 25.9331C26.0007 25.8665 26.2476 25.7864 26.4876 25.6998L26.6707 25.6331C26.874 25.5465 27.0808 25.4564 27.2741 25.3564C27.3002 25.3429 27.327 25.3307 27.3543 25.3198C28.9727 25.9458 30.4419 26.8914 31.6771 28.0944"
      stroke="#141A21"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M36 42C39.3137 42 42 39.3137 42 36C42 32.6863 39.3137 30 36 30C32.6863 30 30 32.6863 30 36C30 39.3137 32.6863 42 36 42Z"
      fill="#91D656"
    />
  </svg>
)

const PinMiniIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M7.97729 1.83578C6.8375 1.79868 5.72953 2.21525 4.89651 2.99408C4.06348 3.7729 3.57343 4.85038 3.53387 5.99009C3.53387 8.98957 7.97729 15.1668 7.97729 15.1668C7.97729 15.1668 12.4207 8.99207 12.4207 5.99009C12.3809 4.85045 11.8908 3.77311 11.0578 2.99433C10.2248 2.21555 9.11702 1.7989 7.97729 1.83578Z"
      stroke="#5F616E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CheckMiniIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
  >
    <path
      d="M4.89844 7.55811L7.02517 9.72255L11.1951 5.59033"
      stroke="#5F616E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.00065 14.1668C11.6825 14.1668 14.6673 11.1821 14.6673 7.50016C14.6673 3.81826 11.6825 0.833496 8.00065 0.833496C4.31875 0.833496 1.33398 3.81826 1.33398 7.50016C1.33398 11.1821 4.31875 14.1668 8.00065 14.1668Z"
      stroke="#5F616E"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export { SkeletonPin, UsermemberIcon, PinMiniIcon, CheckMiniIcon }
